import { render, staticRenderFns } from "./SubPageContent.vue?vue&type=template&id=31e1e988&scoped=true&"
import script from "./SubPageContent.vue?vue&type=script&lang=js&"
export * from "./SubPageContent.vue?vue&type=script&lang=js&"
import style0 from "./SubPageContent.vue?vue&type=style&index=0&id=31e1e988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e1e988",
  null
  
)

export default component.exports